import type { Color } from '../../utils/colors';
import type { LabelCommonProps } from './types';

export const TEXT_COLOR_BY_BACKGROUND_COLOR: Record<
  LabelCommonProps['backgroundColor'],
  Extract<Color, 'neutral100' | 'white100' | 'error100' | 'success100'>
> = {
  error10: 'error100',
  neutral10: 'neutral100',
  success10: 'success100',
  neutral100: 'white100',
  neutral20: 'neutral100',
  pink20: 'neutral100',
  pink40: 'neutral100',
  pink120: 'white100',
  lavander100: 'neutral100',
  white100: 'neutral100',
  yellow20: 'neutral100',
};
